var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"design_box_out"},[_c('p',{staticClass:"design_box_out_title",staticStyle:{"margin-bottom":"0"}},[_c('i',{staticClass:"iconfont iconyou"}),_vm._v(_vm._s(_vm.property.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }